import { formatDate } from '@angular/common';
import { Component, OnInit, signal, computed } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { loadSelfcareOverSightEmployees } from 'src/app/core/store/selfcare/selfcare.actions';
import { SelfCareEmployeeModel } from 'src/app/models/selfcareModels';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { State } from '../../../../core/store';

@Component({
    selector: 'app-selfcare-oversight',
    templateUrl: './selfcare-oversight.component.html',
    styleUrls: ['./selfcare-oversight.component.scss'],
    standalone: false
})
export class SelfcareOversightComponent extends BaseComponent implements OnInit {
  list: SelfCareEmployeeModel[];
  filter: any;
  loadingList = true;

  canViewSelfCareReport;
  
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.selfcareState.loadingOversightList).subscribe(loadingOversightList => {
        this.loadingList = loadingOversightList;
      }),
      this.store.select(s => s.selfcareState.oversightList).subscribe(oversightList => {
        this.list = oversightList;
        if (oversightList != null)
          this.totalRecords.set(oversightList.length);
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canViewSelfCareReport = permissionIDs && !!permissionIDs.find(p => p === 3086); //View Self Care Report
      }),
    );

    this.store.dispatch(loadSelfcareOverSightEmployees());
  }


  openSelfcarePlanner(user) {
    this.openLink(`/selfcare/oversight/${user.id}/main`);
  }

  openLink(path) {
    this.router.navigate([path]);
  }

}
